import React from 'react';
import I18n from 'modules/i18n';
import * as Routes from 'modules/routes';
import { SelectOption } from './types';

interface SignInButtonProps {
  impersonatePath?: string;
  student?: SelectOption;
}

const SignInButton = ({ student, impersonatePath }: SignInButtonProps) => {
  const linkParams = { return_path: window.location.href, ...(impersonatePath && { to_path: impersonatePath }) };
  const linkHref = student ? Routes.student_masquerade_path(student.value, linkParams) : null;
  const linkClass = student ? 'btn btn--purple' : 'btn btn--purple disabled';

  return (
    <a
      className={linkClass}
      href={linkHref}
    >
      {I18n.t('sign_in')}
    </a>
  );
};

export default SignInButton;
